import { useEffect, useState } from "react";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { GoodsStateEditor } from "../GoodsState/GoodsStateEditor";
import { GoodsSupportEditor } from "../GoodsSupport/GoodsSupportEditor";
import { GoodsTypeEditor } from "../GoodsType/GoodsTypeEditor";
import { toast } from "react-toastify";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { PrintJson } from "../../../theme/Component/PrintJson";
interface Props {
    value?: any[];
    onChange?: (data: any[]) => void;
}
export const TransportGuideItemNew = ({ value = [], onChange }: Props) => {

    const [lista, setLista] = useState<any[]>(value);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [modal, setModal] = useState<any>({
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: 'modal-md'
    });

    const [form, setForm] = useState({
        IDGoodsState: null,
        GoodsStateName: null,
        IDGoodsSupport: null,
        GoodsSupportName: null,
        IDGoodsType: null,
        GoodsTypeName: null,
        WeightKg: null,
        WeightKgReal: null,
        LongLength: null,
        WidthLength: null,
        HightLength: null,
        Volume: null,
        Description: null,
        Quantity: null
    });

    useEffect(() => {

        if (!value || value.length === 0) {
            setLista([]);
            return;
        }

        const parsed = value.map((item: any, index: number) => ({
            ID: index + 1,
            IDState: item.DataBeanProperties.IDGoodsState,
            StateName: item.DataBeanProperties.StateName,
            IDSupport: item.DataBeanProperties.IDGoodsSupport,
            SupportName: item.DataBeanProperties.SupportName,
            IDGoodsType: item.DataBeanProperties.IDGoodsType,
            GoodsTypeName: item.DataBeanProperties.GoodsTypeName,
            WeightKg: item.DataBeanProperties.WeightKg,
            WeightKgReal: item.DataBeanProperties.WeightKgReal,
            LongLength: item.DataBeanProperties.LongLength,
            WidthLength: item.DataBeanProperties.WidthLength,
            HightLength: item.DataBeanProperties.HightLength,
            Volume: item.DataBeanProperties.Volume,
            Description: item.DataBeanProperties.Description
        }));

        setLista(parsed);

    }, [value]);

    const handleChange = (e: any) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };
    const updateLista = (data: any[]) => {

        setLista(data);

        if (onChange) {

            const dataBeanList = buildDataBeanList(data);

            onChange(dataBeanList);
        }

    };

    const buildDataBeanList = (data: any[]) => {

        return data.map((item) => ({
            DataBeanProperties: {
                IDGoodsState: item.IDState,
                StateName: item.StateName,
                IDGoodsSupport: item.IDSupport,
                SupportName: item.SupportName,
                IDGoodsType: item.IDGoodsType,
                GoodsTypeName: item.GoodsTypeName,
                WeightKg: item.WeightKg,
                WeightKgReal: item.WeightKgReal,
                LongLength: item.LongLength,
                WidthLength: item.WidthLength,
                HightLength: item.HightLength,
                Volume: item.Volume,
                Description: item.Description
            },
            DataBeanName: "com.quickdataerp.bean.transportguides.TransportGuideItem"
        }));

    };
    const create = () => {

        setIsEditing(false);
        setEditIndex(null);

        setForm({
            IDGoodsState: '',
            GoodsStateName: '',
            IDGoodsSupport: '',
            GoodsSupportName: '',
            IDGoodsType: '',
            GoodsTypeName: '',
            WeightKg: '',
            WeightKgReal: '',
            LongLength: '',
            WidthLength: '',
            HightLength: '',
            Volume: '',
            Quantity: '',
            Description: ''
        });

        setModal({ ...modal, view: true });
    };
    const editar = (index: number) => {

        const item = lista[index];

        setForm({
            IDGoodsState: item.IDState,
            GoodsStateName: item.StateName,
            IDGoodsSupport: item.IDSupport,
            GoodsSupportName: item.SupportName,
            IDGoodsType: item.IDGoodsType,
            GoodsTypeName: item.GoodsTypeName,
            WeightKg: item.WeightKg,
            WeightKgReal: item.WeightKgReal,
            LongLength: item.LongLength,
            WidthLength: item.WidthLength,
            HightLength: item.HightLength,
            Volume: item.Volume,
            Quantity: null,
            Description: item.Description
        });

        setEditIndex(index);
        setIsEditing(true);

        setModal({ ...modal, view: true });
    };
    const limpiarTabla = () => {
        if (window.confirm("¿Desea limpiar todos los registros de la tabla?")) {
            updateLista([]);
        }
    };
    const guardar = () => {

        if (isEditing && editIndex !== null) {

            const nuevaLista = [...lista];

            nuevaLista[editIndex] = {
                ...nuevaLista[editIndex],
                IDState: form.IDGoodsState,
                StateName: form.GoodsStateName,
                IDSupport: form.IDGoodsSupport,
                SupportName: form.GoodsSupportName,
                IDGoodsType: form.IDGoodsType,
                GoodsTypeName: form.GoodsTypeName,
                WeightKg: form.WeightKg,
                WeightKgReal: form.WeightKgReal,
                LongLength: form.LongLength,
                WidthLength: form.WidthLength,
                HightLength: form.HightLength,
                Volume: form.Volume,
                Description: form.Description
            };

            updateLista(nuevaLista);

        } else {

            if (!form.Quantity || form.Quantity <= 0) {
                alert("La cantidad de piezas es obligatoria");
                return;
            }

            const numero = parseInt(form.Quantity);

            let nuevos = [];

            for (let i = 0; i < numero; i++) {

                nuevos.push({
                    ID: lista.length + i + 1,
                    IDState: form.IDGoodsState,
                    StateName: form.GoodsStateName,
                    IDSupport: form.IDGoodsSupport,
                    SupportName: form.GoodsSupportName,
                    IDGoodsType: form.IDGoodsType,
                    GoodsTypeName: form.GoodsTypeName,
                    WeightKg: form.WeightKg,
                    WeightKgReal: form.WeightKgReal,
                    LongLength: form.LongLength,
                    WidthLength: form.WidthLength,
                    HightLength: form.HightLength,
                    Volume: form.Volume,
                    Description: form.Description
                });

            }

            updateLista([...lista, ...nuevos]);
        }

        setModal({ ...modal, view: false });
    };


    return (

        <div className="container">
            <div className="col-md-12">
                <label>Piezas de la Guía</label>
            </div>
            <div className="row mb-3 mt-4">
                <div className="col-md-3">
                    <button
                        className="btn btn-primary"
                        onClick={create}
                    >
                        Agregar
                    </button>
                </div>
                <div className="col-md-3">
                    <button
                        className="btn btn-danger"
                        onClick={limpiarTabla}
                    >
                        Limpiar tabla
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">

                    <table className="table table-striped ">

                        <thead className="">
                            <tr className="table-encabezado">
                                <th>Acciones</th>
                                <th>ID</th>
                                {/* <th>ID Estado</th> */}
                                <th>Estado de Carga</th>
                                {/* <th>ID Soporte</th> */}
                                <th>Soporte de Carga</th>
                                {/* <th>ID Tipo</th> */}
                                <th>Tipo de Carga</th>
                                <th>Peso (Kg)</th>
                                <th>P/Real (Kg)</th>
                                <th>Largo (cm)</th>
                                <th>Ancho (cm)</th>
                                <th>Alto (cm)</th>
                                <th>Volumen</th>
                                <th>Descripción Pieza</th>

                            </tr>
                        </thead>

                        <tbody>

                            {lista.length === 0 && (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        No hay registros
                                    </td>
                                </tr>
                            )}

                            {lista.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <BasicButton icon="ri-more-2-line" clase="table-new" eventClick={() => editar(index)}>
                                        </BasicButton>
                                    </td>
                                    <td>{item.ID}</td>
                                    {/* <td>{item.IDState}</td> */}
                                    <td>{item.StateName}</td>
                                    {/* <td>{item.IDSupport}</td> */}
                                    <td>{item.SupportName}</td>
                                    {/* <td>{item.IDGoodsType}</td> */}
                                    <td>{item.GoodsTypeName}</td>
                                    <td>{item.WeightKg}</td>
                                    <td>{item.WeightKgReal}</td>
                                    <td>{item.LongLength}</td>
                                    <td>{item.WidthLength}</td>
                                    <td>{item.HightLength}</td>
                                    <td>{item.Volume}</td>
                                    <td>{item.Description}</td>

                                </tr>
                            ))}

                        </tbody>

                    </table>
                    {/* <PrintJson json={lista} /> */}

                </div>
            </div>

            <Modal modal={modal} updateModal={setModal} eventModal={guardar}>

                <div className="row">
                    {!isEditing && (
                        <div className="col-md-12">
                            <label>Cantidad de piezas *</label>
                            <input
                                type="number"
                                className="form-control"
                                name="Quantity"
                                value={form.Quantity}
                                onChange={(e) =>
                                    setForm({ ...form, Quantity: e.target.value })
                                }
                            />
                        </div>
                    )}
                    <div className="col-md-6">
                        <GoodsStateEditor render={form.GoodsStateName} idSelector={form.IDGoodsState} onChange={(e) => { setForm({ ...form, "IDGoodsState": e.IDGoodsState, "GoodsStateName": e.Name }) }} returnType="Object" />

                    </div>
                    <div className="col-md-6">

                        <GoodsSupportEditor render={form.GoodsSupportName} idSelector={form.IDGoodsSupport} onChange={(e) => { setForm({ ...form, "IDGoodsSupport": e.IDGoodsSupport, "GoodsSupportName": e.Name }) }} returnType="Object" />

                    </div>
                    <div className="col-md-6">
                        <GoodsTypeEditor render={form.GoodsTypeName} idSelector={form.IDGoodsType} onChange={(e) => { setForm({ ...form, "IDGoodsType": e.IDGoodsType, "GoodsTypeName": e.Name }) }} returnType="Object" />

                    </div>
                    <div className="col-md-6">
                        <label>Peso (Kg)</label>
                        <input type="text" className="form-control" name='WeightKg' value={form.WeightKg} onChange={(e) => { setForm({ ...form, "WeightKg": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>P/Real (Kg)</label>
                        <input type="text" className="form-control" name='WeightKgReal' value={form.WeightKgReal} onChange={(e) => { setForm({ ...form, "WeightKgReal": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Largo (cm)</label>
                        <input type="text" className="form-control" name='LongLength' value={form.LongLength} onChange={(e) => { setForm({ ...form, "LongLength": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Ancho (cm)</label>
                        <input type="text" className="form-control" name='WidthLength' value={form.WidthLength} onChange={(e) => { setForm({ ...form, "WidthLength": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Alto (cm)</label>
                        <input type="text" className="form-control" name='HightLength' value={form.HightLength} onChange={(e) => { setForm({ ...form, "HightLength": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Volumen</label>
                        <input type="text" className="form-control" name='Volume' value={form.Volume} onChange={(e) => { setForm({ ...form, "Volume": e.target.value }) }} />
                    </div>

                    <div className="col-md-12">
                        <label>Descripción Pieza</label>
                        <textarea className="form-control" name='Description' value={form.Description} onChange={(e) => { setForm({ ...form, "Description": e.target.value }) }} />
                    </div>
                </div>

            </Modal>

        </div>
    );
};